// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FireOutlinedSvg from "@ant-design/icons-svg/es/asn/FireOutlined";
import AntdIcon from '../components/AntdIcon';

var FireOutlined = function FireOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FireOutlinedSvg
  }));
};

FireOutlined.displayName = 'FireOutlined';
export default React.forwardRef(FireOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FireOutlined.js
// module id = 1177
// module chunks = 0